module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "navbar-ceil row border-bottom"
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_c('div', {
    staticClass: "navbar-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../../common/assets/img/sjtu.png"),
      "alt": "neobay"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/cgd/by/index')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-title"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$store.state.appName) + "后台\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleMinimize($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/cgd/by/user/login"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" 退出\n\t\t\t\t\t")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-20fd1d2f"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/layout/TopNavBar.vue
// module id = 959
// module chunks = 1